// extracted by mini-css-extract-plugin
module.exports = {"answerPrefix":"QuestionPreview_answerPrefix__LY60a","questionQuestion":"QuestionPreview_questionQuestion__1-GwG"};